export default "/static/dist/sounds/83cb2f83bede68a261d4de9013b29703.mp3";